// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__3Ttx0"};